<div class="registration-child-questions">
  <div class="registration-child-questions-header">
    <h5 class="registration-child-questions-title">{{ 'fgbcl.registration.child.question.title' | translate }}</h5>
    <p
      class="registration-child-questions-instruction m-0"
      [innerHtml]="'fgbcl.registration.child.question.instruction' | translate | markdownTranslate"
    ></p>
  </div>

  <div class="child-question-container" *ngIf="children$ | async as children; else loading">
    <div *ngFor="let child of children; let i = index" class="child-question-card">
      <h5 class="child-question-card-title">
        {{
          'fgbcl.registration.child.question.child.title'
            | translate: { childNum: i + 1, childName: child.FirstName + ' ' + child.LastName }
        }}
      </h5>
      <div *ngFor="let question of child.ClubQuestionAnswer">
        <div [ngSwitch]="question.Question.QuestionType" class="answer">
          <!-- Dropdown -->
          <div *ngSwitchCase="questionType.DropDown">
            <div class="form-floating">
              <select class="form-select" [(ngModel)]="answers[child.RegistrationID + '__' + question.Question.Id]" required>
                <option value="" hidden></option>
                <option *ngFor="let answer of question.Answer" [value]="answer.Id">
                  {{ answer.Answer }}
                </option>
              </select>
              <label>{{ question.Question.Question }}</label>
            </div>
          </div>

          <!-- Multiselect -->
          <div *ngSwitchCase="questionType.MultiSelect">
            <label>{{ question.Question.Question }}</label>
            <div *ngFor="let answer of question.Answer" class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [(ngModel)]="answers[child.RegistrationID + '__' + question.Question.Id + '__' + answer.Id]"
                [name]="child.RegistrationID + '__' + answer.QuestionId"
                [value]="answer.Id"
                [id]="child.RegistrationID + '__' + answer.QuestionId + '__' + answer.Id"
                required
              />
              <label
                class="form-check-label registration-child-question-label"
                [for]="child.RegistrationID + '__' + answer.QuestionId + '__' + answer.Id"
              >
                {{ answer.Answer }}
              </label>
            </div>
          </div>

          <!-- Radio -->
          <div *ngSwitchCase="questionType.Radio">
            <label>{{ question.Question.Question }}</label>
            <div *ngFor="let answer of question.Answer" class="form-check">
              <input
                class="form-check-input"
                type="radio"
                [(ngModel)]="answers[child.RegistrationID + '__' + question.Question.Id]"
                [name]="child.RegistrationID + '__' + answer.QuestionId"
                [value]="answer.Id"
                [id]="child.RegistrationID + '__' + answer.QuestionId + '__' + answer.Id"
                required
              />
              <label
                class="form-check-label registration-child-question-label"
                [for]="child.RegistrationID + '__' + answer.QuestionId + '__' + answer.Id"
              >
                {{ answer.Answer }}
              </label>
            </div>
          </div>

          <!-- Textbox -->
          <div *ngSwitchDefault>
            <div class="form-floating">
              <input
                type="text"
                class="form-control default"
                [(ngModel)]="answers[child.RegistrationID + '__' + question.Question.Id]"
              />
              <label>{{ question.Question.Question }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <fgbcl-errors></fgbcl-errors>

  <ng-template #loading>
    <div class="text-center">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-template>

  <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
</div>
